export default [{
  id: 1,
  key: 'ENTERTAINMENT',
  value: '娱乐'
}, {
  id: 2,
  key: 'SOCIETY',
  value: '社会'
}, {
  id: 3,
  key: 'CARS',
  value: '汽车'
}, {
  id: 4,
  key: 'INTERNATIONAL',
  value: '国际'
}, {
  id: 5,
  key: 'HISTORY',
  value: '历史'
}, {
  id: 6,
  key: 'SPORTS',
  value: '体育'
}, {
  id: 7,
  key: 'HEALTH',
  value: '健康'
}, {
  id: 8,
  key: 'MILITARY',
  value: '军事'
}, {
  id: 9,
  key: 'EMOTION',
  value: '情感'
}, {
  id: 10,
  key: 'FASHION',
  value: '时尚'
}, {
  id: 11,
  key: 'PARENTING',
  value: '育儿'
}, {
  id: 12,
  key: 'FINANCE',
  value: '财经'
}, {
  id: 13,
  key: 'AMUSEMENT',
  value: '搞笑'
}, {
  id: 14,
  key: 'DIGITAL',
  value: '数码'
}, {
  id: 15,
  key: 'EXPLORE',
  value: '探索'
}, {
  id: 16,
  key: 'TRAVEL',
  value: '旅游'
}, {
  id: 17,
  key: 'CONSTELLATION',
  value: '星座'
}, {
  id: 18,
  key: 'STORIES',
  value: '故事'
}, {
  id: 19,
  key: 'TECHNOLOGY',
  value: '科技'
}, {
  id: 20,
  key: 'GOURMET',
  value: '美食'
}, {
  id: 21,
  key: 'CULTURE',
  value: '文化'
}, {
  id: 22,
  key: 'HOME',
  value: '家居'
}, {
  id: 23,
  key: 'MOVIE',
  value: '电影'
}, {
  id: 24,
  key: 'PETS',
  value: '宠物'
}, {
  id: 25,
  key: 'GAMES',
  value: '游戏'
}, {
  id: 26,
  key: 'WEIGHT_LOSING',
  value: '瘦身'
}, {
  id: 27,
  key: 'FREAK',
  value: '奇葩'
}, {
  id: 28,
  key: 'EDUCATION',
  value: '教育'
}, {
  id: 29,
  key: 'ESTATE',
  value: '房产'
}, {
  id: 30,
  key: 'SCIENCE',
  value: '科学'
}, {
  id: 31,
  key: 'PHOTOGRAPHY',
  value: '摄影'
}, {
  id: 32,
  key: 'REGIMEN',
  value: '养生'
}, {
  id: 33,
  key: 'ESSAY',
  value: '美文'
}, {
  id: 34,
  key: 'COLLECTION',
  value: '收藏'
}, {
  id: 35,
  key: 'ANIMATION',
  value: '动漫'
}, {
  id: 36,
  key: 'COMICS',
  value: '漫画'
}, {
  id: 37,
  key: 'TIPS',
  value: '小窍门'
}, {
  id: 38,
  key: 'DESIGN',
  value: '设计'
}, {
  id: 39,
  key: 'LOCAL',
  value: '本地'
}, {
  id: 40,
  key: 'LAWS',
  value: '法制'
}, {
  id: 41,
  key: 'GOVERNMENT',
  value: '政务'
}, {
  id: 42,
  key: 'BUSINESS',
  value: '商业'
}, {
  id: 43,
  key: 'WORKPLACE',
  value: '职场'
}, {
  id: 44,
  key: 'RUMOR_CRACKER',
  value: '辟谣'
}, {
  id: 45,
  key: 'GRADUATES',
  value: '毕业生'
}]
